var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    fillRule: "evenodd",
    d: "M12.471 3.529c.26.26.26.682 0 .942l-8 8a.667.667 0 0 1-.942-.942l8-8c.26-.26.682-.26.942 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    fillRule: "evenodd",
    d: "M3.529 3.529c.26-.26.682-.26.942 0l8 8a.667.667 0 1 1-.942.942l-8-8a.667.667 0 0 1 0-.942",
    clipRule: "evenodd"
  })));
};
export default SvgX;